<template>
  <section class="trendsreport-article-page">
    <div v-if="isArticle" class="trendsreport-article-page__report">
      <div class="trendsreport-article-page__header">
        <div>
          <h1 class="trendsreport-article-page__title">
            {{ selectedProduct.name || 'Report' }}
            <br />
            <small class="trendsreport-article-page__subtitle">
              {{ selectedProduct.reportSubTitle || '' }}
            </small>
          </h1>
        </div>
        <div>
          <img
            src="/images/logos/trendsreport-no-text-logo.svg"
            alt="Trendsreport Logo"
            class="trendsreport-article-page__logo"
          />
        </div>
      </div>
      <div id="reports" class="vueComponent">
        <ReportComponent
          :app-url="app_url"
          :report_to_view="selectedProduct.url"
          :template="selectedProduct.template || null"
          :from_tr="true"
          :sanitized_report="sanitizedSelectedProduct"
          :filename="selectedProduct.name || 'report'"
          :preselected_tr_id="preSelectedId"
          @toggle-favorite="handleFavorite($event)"
          @toggle-alert="handleAlert($event)"
        />
      </div>
    </div>

    <div v-if="isVideo">
      <div class="trendsreport-article-page__header">
        <div>
          <h1 class="trendsreport-article-page__title">
            {{ this.isTrendsTalk ? 'TrendsTalk' : 'Weekly Q&A' }}
          </h1>
        </div>
        <div>
          <img
            src="/images/logos/trendsreport-no-text-logo.svg"
            alt="Trendsreport Logo"
            class="trendsreport-article-page__logo"
          />
        </div>
      </div>
      <div class="trendsreport-article-page__content">
        <div class="trendsreport-article-page__content-media">
          <div class="trendsreport-article-page__content-media-video">
            <iframe
              :src="getVideoUrl"
              frameborder="0"
              webkitAllowFullScreen
              mozallowfullscreen
              allowfullscreen
              class="trendsreport-article-page__content-media-video-iframe"
            />
          </div>
        </div>
        <div class="trendsreport-article-page__content-meta">
          <h3 class="trendsreport-article-page__content-meta-title">
            {{ selectedProduct.title }}
          </h3>
          <p class="trendsreport-article-page__content-meta-date">
            {{ displayDate }}
          </p>
          <div v-html="selectedProduct.short_description" />
        </div>
      </div>

      <div v-if="isQa" class="trendsreport-article-page__question">
        <div class="trendsreport-article-page__question-container">
          <h2 class="trendsreport-article-page__question-title">
            Have questions about your Trends Report™ subscription?
          </h2>
          <p class="trendsreport-article-page__question-text">
            We would love to hear from you! Submit your question(s) by clicking
            the button on this page. Our experts will then provide answers in
            our weekly Q&A video recordings.
          </p>
        </div>
        <BaseButton
          class="trendsreport-article-page__question-button"
          @click="isAskingQuestion = true"
        >
          SUBMIT A QUESTION
        </BaseButton>
      </div>
    </div>
    <div v-if="isAnnouncement">
      <div class="trendsreport-article-page__header">
        <div>
          <h1 class="trendsreport-article-page__title">Recent Announcement</h1>
        </div>
        <div>
          <img
            src="/images/logos/trendsreport-no-text-logo.svg"
            alt="Trendsreport Logo"
            class="trendsreport-article-page__logo"
          />
        </div>
      </div>
      <div class="trendsreport-article-page__content-meta-full">
        <h3 class="trendsreport-article-page__content-meta-full-title">
          {{ selectedProduct.title }}
        </h3>
        <p class="trendsreport-article-page__content-meta-date">
          {{ displayDate }}
        </p>
        <div v-html="selectedProduct.short_description" />
      </div>
    </div>
    <div
      class="trendsreport-article-page__carousel-container"
      v-if="!isPreview"
    >
      <h2 class="trendsreport-article-page__carousel-title">
        {{ carouselText }}
      </h2>
    </div>
    <TrendsReportCarousel
      list-name="more-products"
      :article-list="displayProducts"
      :item-type="selectedProductType"
      :parent-slug="parentSlug"
      :from-index="false"
      @toggle-alert="handleAlert($event)"
      @toggle-favorite="handleFavorite($event)"
      @item-selected="handleItem"
    />
    <div class="trendsreport-article-page__store-container" v-if="!isPreview">
      <div class="trendsreport-article-page__store-itr">
        <img
          src="/images/app-store-itr.png"
          alt="App Store ITR"
          class="trendsreport-article-page__store-image"
        />
        <p class="trendsreport-article-page__store-text">
          Trends Report is on the itr ondemand app!
        </p>
      </div>
      <div class="trendsreport-article-page__store-apps">
        <a
          href="https://play.google.com/store/apps/details?id=com.itrondemand.itrappdev&hl=en_US&gl=US"
          target="_blank"
        >
          <img
            src="/images/app-store-android-tr.png"
            alt="App Store Android"
            class="trendsreport-article-page__app-image"
          />
        </a>
        <a
          href="https://apps.apple.com/us/app/itr-ondemand/id1528665160"
          target="_blank"
        >
          <img
            src="/images/app-store-apple-tr.png"
            alt="App Store Apple"
            class="trendsreport-article-page__app-image last"
          />
        </a>
      </div>
    </div>
  </section>
  <SubmitAQuestionModal
    v-if="isAskingQuestion"
    :webinar="selectedProduct"
    :auth-user="authUser"
    :isQa="true"
    @close="handleCloseQuestionModal"
  />
  <SiteNotifications ref="site-notifications" />
</template>
<script>
  import TrendsReportCarousel from '~/components/trendsreport/TrendsReportCarousel.vue';
  import ReportComponent from '~/components/report/ReportComponent.vue';
  import BaseButton from '~/components/base/BaseButton.vue';
  import SubmitAQuestionModal from '~/components/products/by-the-numbers/SubmitAQuestionModal.vue';
  import SiteNotifications from '~/components/site/SiteNotifications.vue';

  export default {
    name: 'trendsreport-article-page',
    components: {
      TrendsReportCarousel,
      ReportComponent,
      BaseButton,
      SubmitAQuestionModal,
      SiteNotifications,
    },
    props: {
      authUser: {
        type: Object,
        required: true,
      },
      selectedProduct: {
        type: Object,
        required: true,
      },
      selectedProductType: {
        type: String,
        required: true,
      },
      moreProducts: {
        type: Array,
        required: true,
      },
      parentSlug: {
        type: String,
        required: true,
      },
      app_url: {
        type: String,
        required: false,
      },
    },
    data: () => ({
      isIframeFaded: false,
      products: [],
      refreshedSanitizedReport: null,
      isAskingQuestion: false,
      isPreview: false,
      preSelectedId: null,
    }),
    mounted() {
      this.removeIdFromUrl();
      this.preSelectedId = this.selectedProduct.trendsreport_id
        ? this.selectedProduct.trendsreport_id
        : null;
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.products = this.moreProducts;
      const path = new URL(window.location.href).pathname;
      if (path.includes('preview')) this.isPreview = true;
      let splitPath = path.split('/');
      let menuItem = `trendsreport-${splitPath[splitPath.length - 2]}`;
      const event = new CustomEvent('menu-clicked', {
        detail: {
          menuItem: menuItem,
        },
      });
      setTimeout(() => {
        window.dispatchEvent(event);
      }, 1000);
    },
    computed: {
      displayProducts() {
        if (this.isVideo) {
          return this.products.filter(
            (product) => product.id !== this.selectedProduct.id
          );
        }
        if (this.isAnnouncement) {
          return this.products.filter(
            (product) => product.id !== this.selectedProduct.id
          );
        }
        if (this.isArticle) {
          return this.products.filter(
            (product) => product.id !== this.selectedProduct.id
          );
        }
        return this.products;
      },
      displayDate() {
        if (!this.selectedProduct.publish_date) return 'Coming Soon';
        let parsedTimeStamp = new Date(this.selectedProduct.publish_date);
        return parsedTimeStamp.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
      },
      isArticle() {
        return this.selectedProductType === 'article';
      },
      isAnnouncement() {
        return this.selectedProductType === 'announcement';
      },
      isTrendsTalk() {
        return this.selectedProductType.includes('talk');
      },
      isQa() {
        return this.selectedProductType.includes('qa');
      },
      productIconSrc() {
        return `/images/product/icons/${this.selectedProduct.product.toLowerCase().replace(/ /g, '')}-icon.svg`;
      },
      isVideo() {
        return (
          this.selectedProductType === 'trendstalk' ||
          this.selectedProductType === 'qa'
        );
      },
      carouselText() {
        if (this.isVideo) return 'Watch More...';
        if (this.isAnnouncement) return 'Read More...';
        const capitalizedTitle = this.parentSlug.replace(/\b\w/g, (l) =>
          l.toUpperCase()
        );
        if (capitalizedTitle.includes('At-A-Glance')) {
          return `More ${capitalizedTitle} Dashboards`;
        }
        return `More ${capitalizedTitle.replace('-', ' ')}`;
      },
      sanitizedSelectedProduct() {
        if (this.refreshedSanitizedReport) return this.refreshedSanitizedReport;
        if (this.products.length)
          return this.products.filter(
            (product) => product.id === this.selectedProduct.id
          )[0];
        return this.moreProducts.filter(
          (product) => product.id === this.selectedProduct.id
        )[0];
      },
      getVideoUrl() {
        if (this.selectedProductType === 'qa') {
          return `https://player.vimeo.com/video/${this.selectedProduct.vimeo_id}`;
        }
        return `https://www.youtube.com/embed/${this.selectedProduct.youtube_id}`;
      },
    },
    methods: {
      removeIdFromUrl() {
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/');
        const lastSegment = pathSegments[pathSegments.length - 1];

        if (!isNaN(lastSegment)) {
          pathSegments.pop();
          const newPath = pathSegments.join('/');
          history.pushState(null, '', newPath);
        }
      },
      async handleAlert(article) {
        let body = {
          has_notification: article.notifications,
        };
        await axios.post(
          `/trendsreport/${article.id}/tr-toggle-notification`,
          body
        );
        this.getFreshData();
      },
      async handleFavorite(article) {
        let body = {
          is_favorite: article.favorite,
        };
        await axios.post(
          `/trendsreport/${article.id}/tr-toggle-favorite`,
          body
        );
        if (this.parentSlug === 'my-favorites') {
          this.reloadActionItems();
        } else {
          this.getFreshData();
        }
      },
      handleItem(item, slug) {
        return (window.location.href = `/trendsreport/${slug}/${item.slug}`);
      },
      async reloadActionItems() {
        let data = await axios.get(
          `/trendsreport/reload-action-items/${this.parentSlug}/${this.selectedProduct.url}`
        );
        this.products = data.data;
      },
      // getVideoUrl
      // getVimeoVideo() {
      //   return `https://player.vimeo.com/video/${this.selectedProduct.vimeo_id}`
      // },
      // getYTVideo() {
      //   return `https://www.youtube.com/embed/${this.selectedProduct.youtube_id}`
      // },
      async getFreshData() {
        let response = await axios.post(
          `/trendsreport/${this.selectedProduct.id}/tr-refresh-article`
        );
        this.refreshedSanitizedReport = response.data;
      },
      handleCloseQuestionModal(closeData = {}) {
        this.isAskingQuestion = false;

        if (closeData.sentSuccessfully) {
          this.$refs['site-notifications'].addNotification({
            message: 'Question submitted!',
            color: 'success',
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .trendsreport-article-page {
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2rem;
      @include screen-lg {
        margin-bottom: 4rem;
      }
    }
    &__title {
      font-size: 2rem;
      font-weight: 700;
      margin-right: 10px;
    }
    &__logo {
      display: inline;
      height: 48px;
      width: 48px;
    }

    &__content {
      flex: 1 auto;
      display: flex;
      flex-direction: column;
      gap: 32px;

      @include screen-xl {
        flex-direction: row;
      }

      &-media {
        flex: 1 auto;
        &-video {
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          overflow: hidden;
          max-width: 100%;
          height: auto;

          &-iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        }
      }

      &-meta {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;

        &-title {
          color: var(--itr-blue-mid);
          font-size: 30px;
          font-weight: 800;
          width: 100%;
          text-align: left;
          margin: 0;
          line-height: 40px;
        }
        &-date {
          color: var(--itr-grey-mid);
          text-align: left;
          font-size: 18px;
          font-weight: 800;
          padding: 32px 0;
        }
        &-description {
          color: var(--itr-charcoal);
          text-align: left;
          font-weight: 400;
          line-height: 26px;
          margin: 0;
          font-size: 16px;
        }
        &-button {
          padding: 4px 32px;
          overflow: inherit;
          margin: 32px 0;
        }

        @include screen-xl {
          max-width: 310px;
          align-items: flex-end;

          &-title {
            text-align: right;
          }
          &-date {
            text-align: right;
          }
          &-description {
            text-align: right;
            max-width: 297px;
          }
        }
      }
    }

    &__question {
      margin: 4rem 0 3rem 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: 32px;

      &-container {
        flex: 1 auto;
        display: flex;
        flex-direction: column;
      }
      &-title {
        font-size: 35px;
        font-weight: 700;
        margin: 0;
        padding: 0;
        margin-bottom: 16px;
      }
      &-text {
        color: var(--itr-charcoal);
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
        margin: 0;
      }
      &-button {
        padding: 8px 42px;
        overflow: inherit;
      }

      @include screen-md {
        align-items: flex-start;
        justify-content: flex-start;
      }

      @include screen-xl {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: fit-content;
      }
    }

    // &__content-meta {
    //   width: 90%;
    //   text-align: left;
    //   margin-bottom: 2em;
    //   @include screen-md{
    //     width: 33.3333%;
    //     text-align: right;
    //     margin-bottom: 0;
    //   }
    //   &-date{
    //     font-size: 18px;
    //     font-weight: 900;
    //     margin-bottom: 1rem;
    //     color: var(--itr-grey-mid);
    //     @include screen-lg{
    //       margin-bottom: 3rem;
    //     }
    //   }
    //   &-button{
    //     margin-top: 2rem;
    //     text-transform: uppercase;
    //   }
    //   &-title{
    //     color: var(--itr-blue-mid);
    //     margin-bottom: 1rem;
    //     @include screen-lg{
    //       font-size: 30px;
    //       margin-bottom: 3rem;
    //     }
    //   }
    // }
    &__content-meta-full {
      margin-bottom: 1rem;
      width: 100%;
      margin: 0 auto;
      @include screen-lg {
        width: 60%;
      }
      &-title {
        @include screen-lg {
          font-size: 30px;
          margin-bottom: 2rem;
        }
      }
    }
    // &__content-meta-title{
    //   color: var(--itr-blue-mid);
    //   margin-bottom: 1rem;
    //   @include screen-lg{
    //     font-size: 30px;
    //     margin-bottom: 3rem;
    //   }
    // }
    &__carousel-title {
      margin: 2rem 0;
    }
    &__store-container {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 2rem;
      width: 100%;
      padding: 4rem 2rem;
    }
    &__store-itr {
      display: flex;
      align-items: center;
      gap: 10px;
      justify-content: center;
      flex-wrap: wrap;
    }
    &__store-image {
      width: 75px;
      height: 75px;
    }
    &__store-text {
      color: var(--itr-green-mid);
      max-width: 105px;
      font-weight: 600;
      font-size: 12px;
      text-transform: uppercase;
      text-align: center;
      line-height: 1;
    }
    &__store-apps {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
    }
    &__app-image {
      width: 175px;
      height: 50px;
      object-fit: contain;
    }
  }
</style>
